<template>
  <div style="text-align:left;">
    <TopNav />
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <div v-if="admin_datos && admin_datos.superadmin" class="main-container">
        <div class="container-fluid mt-4">
          <div class="d-flex align-items-center mb-3">
            <h3 class="mb-0">Usuarios</h3>
            <span class="ml-3 text-muted" v-if="usuarios.length">{{ usuarios.length }} resultados</span>
          </div>

          <div class="card mb-3 shadow-sm">
            <div class="card-body">
              <div class="form-row align-items-end">
                <div class="col-md-6">
                  <label for="searchTerm">Buscar por correo, nombre o teléfono</label>
                  <input
                    id="searchTerm"
                    v-model="searchTerm"
                    class="form-control"
                    type="text"
                    placeholder="cliente@correo.com"
                    @keyup.enter="fetchUsuarios"
                  />
                </div>
                <div class="col-md-3">
                  <label for="limit">Límite</label>
                  <input
                    id="limit"
                    v-model.number="limit"
                    class="form-control"
                    type="number"
                    min="1"
                    max="200"
                  />
                </div>
                <div class="col-md-3 text-right">
                  <button
                    class="btn btn-primary mt-2"
                    :disabled="loading"
                    @click="fetchUsuarios"
                  >
                    <b-icon icon="search" />
                    {{ loading ? 'Buscando...' : 'Buscar' }}
                  </button>
                </div>
              </div>
              <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
            </div>
          </div>

          <div class="card shadow-sm">
            <div class="card-body p-0">
              <div v-if="loading" class="text-center py-4">Cargando usuarios...</div>
              <div v-else-if="!usuarios.length" class="text-center py-4 text-muted">
                No se encontraron usuarios.
              </div>
              <div v-else class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Correo</th>
                      <th>Nombre</th>
                      <th>Teléfono</th>
                      <th>Tipo</th>
                      <th>Estado</th>
                      <th class="text-right">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="usuario in usuarios" :key="usuario.id" :class="{'table-warning': usuario.suspendido}">
                      <td>{{ usuario.id }}</td>
                      <td>{{ usuario.email }}</td>
                      <td>{{ formatNombre(usuario) }}</td>
                      <td>{{ usuario.telefono || '—' }}</td>
                      <td>
                        <span class="badge" :class="usuarioTipoBadge(usuario)">
                          {{ usuarioTipoLabel(usuario) }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="badge"
                          :class="usuario.suspendido ? 'badge-danger' : 'badge-success'"
                        >
                          {{ usuario.suspendido ? 'Suspendido' : 'Activo' }}
                        </span>
                      </td>
                      <td class="text-right">
                        <div class="action-buttons">
                          <router-link
                            class="btn btn-outline-primary"
                            :to="`/superadmin/Usuarios/${usuario.id}`"
                          >
                            <b-icon icon="box-arrow-up-right" />
                            Ver detalle
                          </router-link>
                          <button
                            class="btn btn-outline-secondary"
                            :disabled="tipoLoading === usuario.id || usuarioTipo(usuario) === 'inversionista'"
                            @click="updateTipo(usuario, 'inversionista')"
                          >
                            <b-icon icon="person-badge" />
                            Convertir a inversionista
                          </button>
                          <button
                            class="btn"
                            :class="usuario.suspendido ? 'btn-success' : 'btn-danger'"
                            :disabled="actionLoading === usuario.id"
                            @click="toggleSuspension(usuario)"
                          >
                            <b-icon :icon="usuario.suspendido ? 'unlock' : 'lock'" />
                            {{ usuario.suspendido ? 'Reactivar' : 'Suspender' }}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import SideNav from '@/components/SideNav.vue'
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'Usuarios',
  components: {
    SideNav,
    TopNav
  },
  data () {
    return {
      searchTerm: '',
      limit: 50,
      usuarios: [],
      loading: false,
      actionLoading: null,
      tipoLoading: null,
      error: ''
    }
  },
  computed: {
    ...mapGetters(['admin_datos'])
  },
  methods: {
    fetchUsuarios () {
      if (!this.admin_datos || !this.admin_datos.superadmin) {
        return
      }

      this.loading = true
      this.error = ''
      axios.get(window.hostname + 'api/admin/usuarios', {
        params: { search: this.searchTerm, limit: this.limit }
      })
        .then(resp => {
          this.usuarios = Array.isArray(resp.data.usuarios) ? resp.data.usuarios : []
        })
        .catch(err => {
          console.error(err)
          this.error = 'No se pudieron cargar los usuarios.'
        })
        .finally(() => {
          this.loading = false
        })
    },
    toggleSuspension (usuario) {
      const action = usuario.suspendido ? 'unsuspend_usuario' : 'suspend_usuario'
      this.actionLoading = usuario.id
      axios.post(window.hostname + `api/admin/${action}`, { usuario_id: usuario.id })
        .then(resp => {
          const updated = resp.data && resp.data.usuario ? resp.data.usuario : null
          if (updated) {
            const idx = this.usuarios.findIndex(u => u.id === updated.id)
            if (idx !== -1) this.$set(this.usuarios, idx, updated)
          } else {
            usuario.suspendido = !usuario.suspendido
          }
          this.$notify({
            group: 'foos',
            title: 'Éxito',
            text: resp.data && resp.data.message ? resp.data.message : 'Estado actualizado.',
            type: 'success'
          })
        })
        .catch(err => {
          console.error(err)
          const message = err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'No se pudo actualizar el estado.'
          this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' })
        })
        .finally(() => {
          this.actionLoading = null
        })
    },
    updateTipo (usuario, tipo) {
      this.tipoLoading = usuario.id
      axios.post(window.hostname + 'api/admin/actualizar_usuario_tipo', {
        usuario_id: usuario.id,
        tipo
      })
        .then(resp => {
          const updated = resp.data && resp.data.usuario ? resp.data.usuario : null
          if (updated) {
            const idx = this.usuarios.findIndex(u => u.id === updated.id)
            if (idx !== -1) this.$set(this.usuarios, idx, updated)
          }
          this.$notify({
            group: 'foos',
            title: 'Éxito',
            text: resp.data && resp.data.message ? resp.data.message : 'Tipo actualizado.',
            type: 'success'
          })
        })
        .catch(err => {
          console.error(err)
          const message = err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'No se pudo actualizar el tipo.'
          this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' })
        })
        .finally(() => {
          this.tipoLoading = null
        })
    },
    formatNombre (usuario) {
      const nombre = usuario.nombre || ''
      const apellidos = usuario.apellidos || ''
      const full = `${nombre} ${apellidos}`.trim()
      return full || '—'
    },
    usuarioTipo (usuario) {
      return (usuario.tipo || 'normal').toString().toLowerCase()
    },
    usuarioTipoLabel (usuario) {
      const tipo = this.usuarioTipo(usuario)
      const labels = {
        inversionista: 'Inversionista',
        normal: 'Usuario'
      }
      return labels[tipo] || tipo
    },
    usuarioTipoBadge (usuario) {
      return this.usuarioTipo(usuario) === 'inversionista' ? 'badge-info' : 'badge-secondary'
    },
    applyRouteSearch () {
      const routeSearch = this.$route && this.$route.query ? this.$route.query.search : ''
      if (routeSearch !== undefined && routeSearch !== null && routeSearch !== this.searchTerm) {
        this.searchTerm = String(routeSearch)
      }
    },
    redirectIfNotSuperadmin () {
      if (this.admin_datos && !this.admin_datos.superadmin) {
        this.$router.push('/')
      }
    }
  },
  mounted () {
    this.applyRouteSearch()
    if (this.admin_datos && this.admin_datos.superadmin) {
      this.fetchUsuarios()
    } else {
      this.redirectIfNotSuperadmin()
    }
  },
  watch: {
    admin_datos: {
      handler (val, oldVal) {
        if (val && val.superadmin && (!oldVal || !oldVal.superadmin) && !this.usuarios.length) {
          this.fetchUsuarios()
        } else if (val && !val.superadmin) {
          this.redirectIfNotSuperadmin()
        }
      },
      deep: true
    },
    '$route.query.search' () {
      this.applyRouteSearch()
      if (this.admin_datos && this.admin_datos.superadmin) {
        this.fetchUsuarios()
      }
    }
  }
}
</script>

<style scoped>
.table-warning {
  background-color: #fff3cd;
}

.action-buttons {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.column-right{
  background-color: rgb(242, 247, 251);
  padding-top:80px;
  padding-left:260px;
  width:100%;
}

.main-container{
  background-color: white;
  margin-top:10px;
  padding:20px 20px 10px 20px;
}

@media (max-width: 800px) {
 .column-right{
  padding-left:0px;
 }
}
</style>
